import NewDialog from 'Components/UI/ConfirmationDialog/NewDialog';
import PropTypes from 'prop-types';
import React from 'react';
import Relationship from 'facet-rest/src/domain/Relationship';
import { dataAttrs } from 'Helpers/Testing';

function MissingInformationConfirmationDialog({
  relationship,
  isOpen,
  setOpen,
  handleNext,
}) {
  if (!relationship || !isOpen) {
    return null;
  }

  return (
    <NewDialog
      title={relationship.meta('title')}
      message={relationship.meta('description')}
      cancelLabel={'Skip for now'}
      confirmLabel={relationship.meta('prompt')}
      confirmButtonType="info"
      onConfirm={() => setOpen(false)}
      onCancel={handleNext}
      onClose={() => {
        setOpen(false);
      }}
      showCloseIcon={false}
      {...dataAttrs('missing-information-confirmation-dialog')}
      maxWidth={'sm'}
    />
  );
}

MissingInformationConfirmationDialog.defaultProps = {
};

MissingInformationConfirmationDialog.propTypes = {
  relationship: PropTypes.instanceOf(Relationship).isRequired,
  isOpen: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
};

export default MissingInformationConfirmationDialog;
